// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"34fc90d8","34":"dba1c2cf","453":"d855a71b","455":"1d6c112f","562":"f5d2d03f","847":"09add95c","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};